import { AppViewModel } from '../../app/app.vm';

interface Props {
    appVm: AppViewModel;
}

export default function RequestsView(props: Props) {
    return <div>requests</div>;
}
